import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

let serverUrl = appConfig.server_url


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_GROUPS(state, groups) {
    state.cached = groups
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchGroups(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/groups/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_GROUPS', request)
      return request
    })
  },

  fetchGroupsDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateGroups(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/base/groups/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deleteGroups(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}